module.exports = __webpack_public_path__ + "img/b2binpay.e5543240.svg";